(($) => {
    $(document).ready(() => {
        $('.select-country').on('change', function () {
            let that = $(this);
            let state = that.closest('form').find('.state-wapper').show();

            let value = $(this).val();
            if (value == 'United States') {
                state.find('select').attr('required', true);
                state.show();
            } else {
                state.find('select').attr('required', false);
                state.hide();
            }
        });

        $('.select-country').each((idx, elm) => {
            $(elm).trigger('change');
        })
    });
})(jQuery);